import { dequal } from "dequal"

/**
 *
 * @param current object
 * @param initial object
 * @returns an object containing only the properties of current, which are different from initial.
 */

export const difference = (current: object, initial: any): object =>
	Object.entries(current)
		.filter(([key, value]) => !dequal(value, initial[key]))
		.reduce((result, [key, value]) => ({ ...result, [key]: value }), {})
